import { render, staticRenderFns } from "./ChoosingRenedian.vue?vue&type=template&id=6f2fe02d"
import script from "./ChoosingRenedian.vue?vue&type=script&lang=js"
export * from "./ChoosingRenedian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports